import React, { useCallback, useEffect, useState } from 'react';

const INTRO_DURATION = 7000;
const EXIT_DURATION = 600;

const LoadingScreen = ({ onFinish, duration = INTRO_DURATION }) => {
  const [isExiting, setIsExiting] = useState(false);

  const finishWithExit = useCallback(() => {
    if (isExiting) return;
    setIsExiting(true);
    setTimeout(() => {
      onFinish();
    }, EXIT_DURATION);
  }, [isExiting, onFinish]);

  useEffect(() => {
    const timer = setTimeout(() => {
      finishWithExit();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, finishWithExit]);

  return (
    <div
      className={`loading-overlay${isExiting ? ' loading-overlay--exit' : ''}`}
      role="dialog"
      aria-modal="true"
      aria-label="Welcome animation"
    >
      <div className="loading-overlay-backdrop" aria-hidden="true">
        <div className="loading-overlay-gradient" />
        <div className="loading-overlay-window" />
      </div>
      <div className="loading-overlay-content">
        <div className="loading-gate-scene" aria-hidden="true">
          <div className="loading-sky" />
          <img
            src="/images/ttss.jpeg"
            alt="Trivandrum Scottish School"
            className="loading-school-image"
          />

          <div className="loading-gate-structure">
            <div className="loading-gate-post loading-gate-post--left">
              <div className="loading-post-cap" />
            </div>

            <div className="loading-gate-door loading-gate-door--left">
              <div className="loading-gate-arch loading-gate-arch--left" />
              <div className="loading-gate-bars" />
              <div className="loading-gate-band">
                <span className="loading-gate-band__crest">✶</span>
                <span className="loading-gate-band__text">The Trivandrum</span>
              </div>
            </div>

            <div className="loading-gate-door loading-gate-door--right">
              <div className="loading-gate-arch loading-gate-arch--right" />
              <div className="loading-gate-bars" />
              <div className="loading-gate-band">
                <span className="loading-gate-band__text">Scottish School</span>
              </div>
            </div>

            <div className="loading-gate-post loading-gate-post--right">
              <div className="loading-post-cap" />
            </div>
          </div>

          <div className="loading-gate-path" />
          <span className="loading-gate-heading">
            <span className="loading-heading-line">Welcome to</span>
            <img
              src="/ttss_logo.png"
              alt="TTSS"
              className="loading-heading-logo"
            />
          </span>
        </div>
        <button type="button" className="loading-skip" onClick={finishWithExit}>
          Skip intro
        </button>
      </div>
    </div>
  );
};

export default LoadingScreen;

